import React, { useState, useEffect, useContext } from "react";
import { Card, Col, Row } from "react-bootstrap";
import UserShortLinks from "./userShortLinks";

const UserLinksIcons = (props) => {
  return (
    <>
      <Card>
        <Card.Header className="card-header-bg text-uppercase fw-bold">
          Quick Links
        </Card.Header>
        <Card.Body className="p-0 mt-1">
          <UserShortLinks />
        </Card.Body>
      </Card>
    </>
  );
};
export default UserLinksIcons;
